import React from 'react';

type Props = {
  content: React.ReactNode;
};

export default function ModalMessage({ content }: Props) {
  return (
    <div className="flex h-full w-full items-center justify-center text-base font-normal leading-[140%] tracking-[-0.32px] text-apps-coreGray02">
      {content}
    </div>
  );
}
